var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrestige(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "8px",
    viewBox: "0 0 10.0 8.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30846325,0 L2.71158129,2.04899777 L0,2.04899777 L1.34966592,0 L3.30846325,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6325167,0 L4.33184855,4.69487751 L0,0 L2.6325167,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.31848552,0 L0,4.69042316 L1.70155902,0 L4.31848552,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94097996,0 L3.29064588,2.04899777 L0.59688196,2.04899777 L0,0 L1.94097996,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63028953,0 L2.0155902,4.44877506 L1.81291759,5.00890869 L1.6091314,4.44766147 L0,0 L3.63028953,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0701559,0 L3.66703786,2.04899777 L0,2.04899777 L0.59688196,0 L3.0701559,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 -1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.30846325,0 3.30846325,2.04899777 0,2.04899777 0,0",
    stroke: "none",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08685968819638035 2.4944320712693866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.33184855,0 4.33184855,4.69487751 0,4.69487751 0,0",
    stroke: "none",
    fill: "#282828"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.595768374165207 2.494432071269493)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.31848552,0 4.31848552,4.69042316 0,4.69042316 0,0",
    stroke: "none",
    fill: "#282828"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.709354120266827 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.29064588,0 3.29064588,2.04899777 0,2.04899777 0,0",
    stroke: "none",
    fill: "#282828"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.193763919821828 2.494432071269493)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.63028953,0 3.63028953,5.00890869 0,5.00890869 0,0",
    stroke: "none",
    fill: "#282828"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.1748329621386153 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.66703786,0 3.66703786,2.04899777 0,2.04899777 0,0",
    stroke: "none",
    fill: "#282828"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestige);
export default __webpack_public_path__ + "static/media/prestige.6753599f91622a4f5daf9bf6bef9e1c9.svg";
export { ForwardRef as ReactComponent };